import functionsMixins from "@/mixins/page/functionsMixins";
import {crudGeneral} from "@/services/resource/GeneralCRUD.service";
import CurrentPageEntity from "@/model/entities/resource/entity/CurrentPageEntity";
import UserAuthEntity from "@/model/entities/resource/entity/UserAuthEntity";

export default {
    mixins: [functionsMixins],
    data() {
        return {
            path: "",
            form: {},
            error: {},
            status: "",
            busy: false,
            generalErrors: [],
            dialogIsLoaded: false,
            primaryKeyColumn: "",/*Declarado para ser sobreposto*/
            genKey: false, //Por padrão os formulários não possuem gerador de chave temporária
            enableGeneralFields: false,
            yesOrNotOptions: [{value: "Y", text: this.t('yes')}, {value: "N", text: this.t('no')}],
            itemInserted: {
                groupId: 0,
                value: 0,
                text: "",
            },
            currentPage: CurrentPageEntity,
            userAuth: UserAuthEntity,
        }
    },
    watch:{
        setUserAuth(v){
            this.userAuth = v
        }
    },
    props: {
        command: {
            type: String,
            default: 'insert'
        },
        noOptionAdd: String,
        primaryKey: Number,
        setUserAuth: Object,
        foreignKey: {
            type: Number,
            default: 0,
            required: false,
        },
        /*NUNCA PODERÁ DECLARAR AQUI foreignKeyColumn, POIS EXISTE TELAS QUE UTILIZAM EM DATA*/
    },

    async mounted() {

        this.userAuth = this.setUserAuth

        await this.mountedContinued()



    },

    methods: {

        //Método declarado para ser sobreposto
        async mountedContinued() {

        },

        async setSubmitDialogDefault() {

            await this.executeSubmitDialog(this.path, this.command, () => {
                this.successInsert()
            })

        },

        async executeSubmitDialog(path, command, callback) {

            this.status = "sending"
            this.checkErrorsComponent = false


            if (command === 'delete') {

                await crudGeneral.remove(path, this.primaryKey).then(response => {

                    callback(response.data)

                }).catch(error => this.responseError(error))

            } else {

                //Limpa campos de erros (caso existam)
                Object.keys(this.error).forEach(key => {
                    this.error[key] = ""
                });


                //Crud enviado, por tanto será feito de forma automatica a inclusão e alteração
                await crudGeneral.save(path, command, this.form).then(response => {
                    callback(response.data)
                }).catch(error => this.responseError(error))


            }


        },

        async putDialog(path, callback) {

            this.status = "sending"
            this.checkErrorsComponent = false

            await this.executeSubmitDialog(path, 'update', callback)

        },


        async setInsertDialog(path, callback) {

            this.status = "sending"
            this.checkErrorsComponent = false

            //console.log(path, callback)

            await this.executeSubmitDialog(path, 'insert', callback)

        },

        onClose() {

            this.resetModal()

            this.$emit("onClose")

        },

        resetModal() {

            this.status = ""

            //Limpa os campos primitivos do formulário de forma automatica
            this.resetFormDefault(this.form)

            //this.$refs.dialog_form.setReset()

        },

        getEmbedAddressApi(el, address) {

            this.form[el].street = address.street
            this.form[el].neighborhood = address.neighborhood
            this.form[el].provinceAbbreviation = address.provinceAbbreviation
            this.form[el].cityId = address.cityId

        },

        async readModal(changeBusy = false) {

            if (this.genKey && this.isInsert()) {

                await crudGeneral.get(this.path + "/createId").then(
                    response => {
                        this.form[this.primaryKeyColumn] = response.data.id
                        this.genKey = false //Indica que a chave já foi criada
                    }
                ).catch(error => this.responseError(error))

                if (changeBusy)
                    this.busy = false


            } else if (this.command !== 'insert') {

                if (changeBusy)
                    this.busy = true

                await crudGeneral.getById(this.path, this.primaryKey).then(
                    (response) => {

                        this.form = response.data

                        if (changeBusy)
                            this.busy = false

                    }
                ).catch(error => this.responseError(error))

            }

        },

        successInsert() {

            setTimeout(() => {

                //Fecha e devolve os valores desejado para continuidade
                this.$nextTick(() => {

                    this.$bvModal.hide(this.id)
                    this.$emit('onSubmit', this.itemInserted)

                });

            }, 50)

        },

        responseError(error) {

            //Retorna o status para o padrão de tentativa de subject enviado
            this.status = "subject"

            if (error.response) {

                if (error.response.status === 500) {


                    if (error.response.data && error.response.data.message) {

                        this.generalErrors = []
                        this.generalErrors.push(error.response.data.message)

                    } else {

                        const general = error.response.data.general
                        const fields = error.response.data.fields

                        if (general && general.length > 0) {
                            this.generalErrors = general
                        }

                        Object.keys(fields).forEach(key => {

                            if (key.indexOf(".") > 0) {

                                const obj = key.substring(0, key.indexOf("."))
                                const objField = key.replace(obj + ".", '')

                                if ([objField] in this["error_" + obj]) {
                                    this["error_" + obj][objField] = fields[key]
                                } else {
                                    alert('Falha encontrada campo relacionado: ' + key + ' - ' + fields[key])
                                }

                                //console.log("Objeto [" + obj + "]")
                                //console.log("Field [" + objField + "]")

                            } else {

                                if ([key] in this.error) {
                                    this.error[key] = fields[key]
                                } else {
                                    alert('Falha encontrada campo: ' + key + ' - ' + fields[key])
                                }

                            }


                        });

                    }


                    //Marca para os componentes de formulario realizarem nova verificação interna (usado principalmente em Tabs)
                    this.checkErrorsComponent = true
                    //-----------------------------------------------------------------------------------------------------------


                } else if (error.response.status === 400) {

                    alert('Falha ao tentar enviar, por favor tente novamente ou informe nosso suporte técnico o seguinte erro: 400')
                    console.warn(error.response);

                }

            } else if (error.request) {
                // The request was made but no response was received
                alert('Falha de conexão, verifique sua internet 2')
                console.warn(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                alert('Falha de conexão, verifique sua internet 3')
                console.log(error)
                console.warn('Error', error.message);
            }

        },


    },


}


